import { z } from "zod";
import { usePlatformStore } from "@platform/store";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import { baseSupportSchema } from "@core/features/support";
import { Dialog } from "@themes/pollinator/ui/Dialog";
import { useForm } from "@core/features/form";
import { Form } from "@themes/pollinator/ui/Form";
import { FormField } from "@themes/pollinator/ui/FormField";
import { useDialog } from "@platform/store";

export function SupportTicketFormContainer() {
  const user = usePlatformStore((s) => s.user);
  const { activeDialog, closeDialog } = useDialog();

  const isOpen = activeDialog === "supportTicket";

  const schema = baseSupportSchema;

  const submitSupportTicket = useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return await apiRequest("/send-support-ticket/", "POST", data, false);
    },
  });

  const { form, handleSubmit, handleClose } = useForm({
    schema,
    defaultValues: {
      email: user?.email ?? "",
      message: "",
    },
    onSubmit: submitSupportTicket.mutateAsync,
    onClose: () => closeDialog(),
  });

  const { isSubmitting, isValid, isSubmitSuccessful } = form.formState;

  return (
    <Dialog
      isOpen={isOpen}
      isWithActions={!isSubmitSuccessful}
      onClose={handleClose}
      title={isSubmitSuccessful ? "Success!" : "Get Help"}
      description={
        isSubmitSuccessful
          ? "Thank you, we'll get back to you shortly."
          : "Send us a message, we'll get back to you as soon as possible."
      }
      primaryButtonText="Submit"
      onPrimaryClick={handleSubmit}
      onSecondaryClick={handleClose}
      secondaryButtonText="Cancel"
      primaryButtonProps={{
        disabled: isSubmitting,
        visuallyDisabled: !isSubmitting && !isValid,
        type: "submit",
      }}
      secondaryButtonProps={{
        disabled: isSubmitting,
      }}
    >
      {!isSubmitSuccessful && (
        <Form form={form} className="py-8" errorContainerClassName="p-0 mt-8">
          <FormField
            name="email"
            label="Email"
            component="Input"
            placeholder="Enter your email"
            autoComplete="username"
            required
          />
          <FormField
            name="message"
            label="Message"
            component="Textarea"
            placeholder="Your message"
            required
          />
        </Form>
      )}
    </Dialog>
  );
}

export default SupportTicketFormContainer;

